<script lang="ts">
    import EvalModelsPage from '@Evaluation/EvaluationModels/Pages/EvalModelsPage'
    export default EvalModelsPage
</script>

<template>
    <div>
        <EvalModelBuilder :viewModel="evalModelBuilder" @create-evalmodel="handleCreateEvalModelCommand" />
        <EvalModelCloner :viewModel="evalModelCloner" @clone-evalmodel="handleCloneEvalModelCommand" />
        <EvalModelDeleter :viewModel="evalModelDeleter" @delete-evalmodel="handleDeleteEvalModelCommand" />
        <EvalModelEditor :viewModel="evalModelEditor" @update-evalmodel="handleRenameGoalCommand" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Goals</h1>
                </div>
                <div class="col-lg-6 text-right">
                    <button role="button" class="btn btn-success" style="padding: 0.7em 2em;" @click="showGoalCreator">Create goal</button>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />

        <div class="container">
            <h3 v-if="!rm"><i class="fa fa-spinner fa-spin"></i> Loading... </h3>
            <div v-if="rm">
                <div class="row">
                    <div class="col-lg-4 offset-lg-8">
                        <div class="input-group input-group-lg">
                            <input type="search" placeholder="Search" class="form-control" v-model="SearchPhrase">
                            <span class="input-group-append">
                                <span class="input-group-text"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></span>
                            </span>
                        </div>
                    </div>
                </div>

                <table class="table table-bordered table-hover table-browser mt-3">
                    <thead>
                        <tr>
                            <th class="sortable" @click="OrderByNameCommand" :class="{'selected': OrderBy === 'name'}">
                                <span class="text-uppercase font-weight-normal">Name</span>

                                <span class="fa-stack">
                                    <i class="fa fa-sort-asc fa-stack-1x" :class="{'selected': (OrderBy === 'name' && OrderByDescending === false)}"></i>
                                    <i class="fa fa-sort-desc fa-stack-1x" :class="{'selected' : (OrderBy === 'name' && OrderByDescending === true)}"></i>
                                </span>
                            </th>
                            <th class="sortable text-center" style="width: 180px;" @click="OrderByCreatedCommand" :class="{'selected': OrderBy === 'created'}">

                                <span class="text-uppercase font-weight-normal">Created on</span>

                                <span class="fa-stack">
                                    <i class="fa fa-sort-asc fa-stack-1x" :class="{'selected' : (OrderBy === 'created' && OrderByDescending === false)}"></i>
                                    <i class="fa fa-sort-desc fa-stack-1x" :class="{'selected' : (OrderBy === 'created' && OrderByDescending === true)}"></i>
                                </span>
                            </th>

                            <th style="padding: 1em 1.5em; width: 90px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="g in ProjectsView" :key="g.EvalModelId">
                            <td>
                                <a class="text-dark" v-sanitizedHref="urlGoalRelativePath(g.EvalModelId)">
                                    <span>{{g.Goal}}</span>
                                </a>
                            </td>
                            <td class="text-center">
                                <span>{{formatDate(g.Created)}}</span><br />
                                <small>{{formatTime(g.Created)}}</small>
                            </td>
                            <td>
                                <div class="dropdown">
                                    <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                        Actions
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" @click="showGoalEditor(g)">Rename</a>
                                        <a class="dropdown-item" @click="showGoalCloner(g)">Clone</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="showGoalDeleter(g)">Delete</a>
                                    </div>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
